module.exports = __webpack_public_path__ + "static/img/b4.25ad32d.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/index/zh/b4.png
// module id = Wovy
// module chunks = 0